export default __webpack_public_path__ + "static/media/432.2c3dc252.png";